export default "__VITE_ASSET__e62b75e9__"